<template>
  <div class="member-registration" :class="{ 'fullscreen': isFullscreen }" :style="fullscreenBgStyle">
    <div v-if="isFullscreen" class="circuit-lines"></div>
    <div v-if="isFullscreen" class="bike-decoration top-left">
      <svg viewBox="0 0 24 24" fill="currentColor" style="width: 100%; height: 100%; color: #009a44;">
        <path d="M5 20.5A3.5 3.5 0 0 1 1.5 17A3.5 3.5 0 0 1 5 13.5A3.5 3.5 0 0 1 8.5 17A3.5 3.5 0 0 1 5 20.5M5 12A5 5 0 0 0 0 17A5 5 0 0 0 5 22A5 5 0 0 0 10 17A5 5 0 0 0 5 12M14.8 10H19V8.2H15.8L13.86 4.93C13.57 4.43 13 4.1 12.4 4.1C11.93 4.1 11.5 4.29 11.2 4.64L10.3 5.7L13.2 7.8L13.05 8.1L10.7 6.35L8.95 8.65L11.9 10.8L14.8 10M19 20.5A3.5 3.5 0 0 1 15.5 17A3.5 3.5 0 0 1 19 13.5A3.5 3.5 0 0 1 22.5 17A3.5 3.5 0 0 1 19 20.5M19 12A5 5 0 0 0 14 17A5 5 0 0 0 19 22A5 5 0 0 0 24 17A5 5 0 0 0 19 12Z"/>
        <path d="M15.5 17H22.5" stroke="currentColor" stroke-width="0.8" fill="none"/>
        <circle cx="5" cy="17" r="2" fill="none" stroke="currentColor" stroke-width="0.8"/>
        <circle cx="19" cy="17" r="2" fill="none" stroke="currentColor" stroke-width="0.8"/>
      </svg>
    </div>
    <div v-if="isFullscreen" class="bike-decoration bottom-right">
      <svg viewBox="0 0 24 24" fill="currentColor" style="width: 100%; height: 100%; color: #2ecc71;">
        <path d="M5 20.5A3.5 3.5 0 0 1 1.5 17A3.5 3.5 0 0 1 5 13.5A3.5 3.5 0 0 1 8.5 17A3.5 3.5 0 0 1 5 20.5M5 12A5 5 0 0 0 0 17A5 5 0 0 0 5 22A5 5 0 0 0 10 17A5 5 0 0 0 5 12M14.8 10H19V8.2H15.8L13.86 4.93C13.57 4.43 13 4.1 12.4 4.1C11.93 4.1 11.5 4.29 11.2 4.64L10.3 5.7L13.2 7.8L13.05 8.1L10.7 6.35L8.95 8.65L11.9 10.8L14.8 10M19 20.5A3.5 3.5 0 0 1 15.5 17A3.5 3.5 0 0 1 19 13.5A3.5 3.5 0 0 1 22.5 17A3.5 3.5 0 0 1 19 20.5M19 12A5 5 0 0 0 14 17A5 5 0 0 0 19 22A5 5 0 0 0 24 17A5 5 0 0 0 19 12Z"/>
        <path d="M15.5 17H22.5" stroke="currentColor" stroke-width="0.8" fill="none"/>
        <circle cx="5" cy="17" r="2" fill="none" stroke="currentColor" stroke-width="0.8"/>
        <circle cx="19" cy="17" r="2" fill="none" stroke="currentColor" stroke-width="0.8"/>
      </svg>
    </div>
    <div v-if="isFullscreen" class="fullscreen-header">
      <div class="logo-container">
        <img :src="require('@/assets/image/left_logo.png')" alt="Ananda Logo" class="logo" />
      </div>
      <div class="language-switch">
        <el-dropdown class="custom-dropdown" popper-class="custom-dropdown-popper">
          <span class="el-dropdown-link">
            <el-icon style="margin-right: 5px;"><Switch /></el-icon>
            {{ currentLanguage }}
            <el-icon><ArrowDown /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item v-for="(lang, key) in supportedLanguages" :key="key" @click="changeLanguage(key)">
                {{ key }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <div class="registration-wrapper">
      <div class="registration-container">
        <div class="form-header">
          <h2 class="form-title">{{ $t('MemberRegistration.title') }}</h2>
          <p class="form-subtitle">{{ $t('MemberRegistration.subtitle') }}</p>
        </div>

        <el-form ref="registrationForm" :model="formData" :rules="formRules" class="registration-form" label-width="160px" label-position="right">
          <div class="form-section">
            <h3 class="section-title">{{ $t('MemberRegistration.contactInformation') }}</h3>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('MemberRegistration.email') + '*'" prop="email">
                  <el-input v-model="formData.email" :placeholder="$t('MemberRegistration.enterEmail')" @blur="handleEmailBlur" />
                </el-form-item>

              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('MemberRegistration.storeName') + '*'" prop="storeName">
                  <el-input v-model="formData.storeName" :placeholder="$t('MemberRegistration.enterStoreName')" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-if="isFullscreen" :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('MemberRegistration.verifyCode') + '*'" prop="verifyCode">
                  <div class="verify-code-wrapper">
                    <el-input v-model="formData.verifyCode" :placeholder="$t('MemberRegistration.enterVerifyCode')" />
                    <el-button 
                      type="primary" 
                      @click="handleSendVerifyCode" 
                      :disabled="isSendingCode || !formData.email || codeCountdown > 0"
                      class="send-code-btn"
                    >
                      {{ codeCountdown > 0 ? `${codeCountdown}s` : $t('MemberRegistration.sendVerifyCode') }}
                    </el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('MemberRegistration.contactName') + '*'" prop="contactName">
                  <el-input v-model="formData.contactName" :placeholder="$t('MemberRegistration.enterContactName')" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('MemberRegistration.tel') + '*'" prop="tel">
                  <el-input v-model="formData.tel" :placeholder="$t('MemberRegistration.enterTel')" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('MemberRegistration.country') + '*'" prop="country">
                  <el-select v-model="formData.country" :placeholder="$t('MemberRegistration.selectCountry')" filterable style="width: 100%">
                    <el-option v-for="country in countryOptions" :key="country.code" :label="country.label" :value="country.code" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('MemberRegistration.postCode') + '*'" prop="postCode">
                  <el-input v-model="formData.postCode" :placeholder="$t('MemberRegistration.enterPostCode')" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item :label="$t('MemberRegistration.location') + '*'" prop="location">
                  <el-input v-model="formData.location" :placeholder="$t('MemberRegistration.enterLocation')" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('MemberRegistration.taxNumber') + '*'" prop="taxNumber">
                  <el-input v-model="formData.taxNumber" :placeholder="$t('MemberRegistration.enterTaxNumber')" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="24">
                <el-form-item :label="$t('MemberRegistration.website')" prop="website">
                  <el-input v-model="formData.website" :placeholder="$t('MemberRegistration.enterWebsite')" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <div class="form-section compact-section">
            <h3 class="section-title">{{ $t('MemberRegistration.businessLicense') }}</h3>
            <el-form-item :label="$t('MemberRegistration.businessLicense')" prop="businessLicense" label-width="auto">
              <div class="upload-area">
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :file-list="fileList"
                  :on-change="handleFileChange"
                  :on-success="handleUploadSuccess"
                  :on-error="handleUploadError"
                  :http-request="handleCustomUpload"
                  accept=".pdf,.jpg,.jpeg,.png"
                  :auto-upload="false"
                  ref="uploadRef"
                >
                  <el-button type="primary" class="upload-button">
                    <el-icon><Plus /></el-icon>
                    {{ $t('MemberRegistration.uploadFile') }}
                  </el-button>
                  <template #tip>
                    <div class="upload-tip">
                      {{ $t('MemberRegistration.supportFormats') }}
                    </div>
                  </template>
                </el-upload>
              </div>
            </el-form-item>
          </div>

          <div class="form-section compact-section">
            <h3 class="section-title">{{ $t('MemberRegistration.businessInformation') }}</h3>
            
            <el-form-item :label="$t('MemberRegistration.workWithAnanda') + '*'" prop="workWithAnanda" label-width="auto">
              <el-radio-group v-model="formData.workWithAnanda">
                <el-radio label="yes">{{ $t('MemberRegistration.yes') }}</el-radio>
                <el-radio label="no">{{ $t('MemberRegistration.no') }}</el-radio>
              </el-radio-group>
            </el-form-item>

            <div v-if="formData.workWithAnanda === 'yes'" class="conditional-section">
              <el-form-item :label="$t('MemberRegistration.howKnowAnanda') + '*'" prop="howKnowAnanda" label-width="auto">
                <el-checkbox-group v-model="formData.howKnowAnanda">
                  <el-checkbox label="exhibition">{{ $t('MemberRegistration.exhibition') }}</el-checkbox>
                  <el-checkbox label="magazines">{{ $t('MemberRegistration.magazines') }}</el-checkbox>
                  <el-checkbox label="socialMedia">{{ $t('MemberRegistration.socialMedia') }}</el-checkbox>
                  <el-checkbox label="supplier">{{ $t('MemberRegistration.supplier') }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item :label="$t('MemberRegistration.whyChooseAnanda') + '*'" prop="whyChooseAnanda" label-width="auto">
                <el-checkbox-group v-model="formData.whyChooseAnanda">
                  <el-checkbox label="qualityPrice">{{ $t('MemberRegistration.qualityPrice') }}</el-checkbox>
                  <el-checkbox label="differentiation">{{ $t('MemberRegistration.differentiation') }}</el-checkbox>
                  <el-checkbox label="supplierAdvice">{{ $t('MemberRegistration.supplierAdvice') }}</el-checkbox>
                  <el-checkbox label="other">{{ $t('MemberRegistration.other') }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item v-if="formData.whyChooseAnanda.includes('other')" :label="$t('MemberRegistration.additionalInfo')" prop="additionalInfo" label-width="auto">
                <el-input type="textarea" v-model="formData.additionalInfo" :rows="3" :placeholder="$t('MemberRegistration.enterAdditionalInfo')" />
              </el-form-item>

              <el-form-item prop="subscribeNewsletter" label-width="auto">
                <el-checkbox v-model="formData.subscribeNewsletter">
                  {{ $t('MemberRegistration.subscribeNewsletter') }}
                </el-checkbox>
              </el-form-item>
            </div>
          </div>

          <div class="form-section compact-section">
            <h3 class="section-title">{{ $t('MemberRegistration.storeSize') }}</h3>
            
            <div class="form-row">
              <el-form-item :label="$t('MemberRegistration.officeArea') + '*'" prop="officeArea" label-width="auto">
                <el-select v-model="formData.officeArea" :placeholder="$t('MemberRegistration.selectOfficeArea')">
                  <el-option label="< 20m²" value="less20" />
                  <el-option label="20-50m²" value="20-50" />
                  <el-option label="50-100m²" value="50-100" />
                  <el-option label="> 100m²" value="more100" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('MemberRegistration.warehouse') + '*'" prop="warehouse" label-width="auto">
                <el-select v-model="formData.warehouse" :placeholder="$t('MemberRegistration.selectWarehouse')">
                  <el-option label="< 50m²" value="warehouse_less50" />
                  <el-option label="50-100m²" value="warehouse_50-100" />
                  <el-option label="100-200m²" value="warehouse_100-200" />
                  <el-option label="> 200m²" value="warehouse_more200" />
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('MemberRegistration.staff') + '*'" prop="staff" label-width="auto">
                <el-select v-model="formData.staff" :placeholder="$t('MemberRegistration.selectStaff')">
                  <el-option label="< 5 persons" value="staff_less5" />
                  <el-option label="5-10 persons" value="staff_5-10" />
                  <el-option label="10-20 persons" value="staff_10-20" />
                  <el-option label="> 20 persons" value="staff_more20" />
                </el-select>
              </el-form-item>
            </div>
          </div>

          <div class="form-section compact-section">
            <h3 class="section-title">{{ $t('MemberRegistration.serviceCoverage') }}</h3>
            
            <el-form-item :label="$t('MemberRegistration.serviceCapabilities') + '*'" prop="serviceCapabilities" label-width="auto">
              <el-checkbox-group v-model="formData.serviceCapabilities" class="checkbox-grid">
                <el-checkbox label="hotLine">{{ $t('MemberRegistration.serviceHotLine') }}</el-checkbox>
                <el-checkbox label="service5d8h">{{ $t('MemberRegistration.service5d8h') }}</el-checkbox>
                <el-checkbox label="bikeRepair">{{ $t('MemberRegistration.bikeRepair') }}</el-checkbox>
                <el-checkbox label="electricalRepair">{{ $t('MemberRegistration.electricalRepair') }}</el-checkbox>
                <el-checkbox label="spareParts">{{ $t('MemberRegistration.spareParts') }}</el-checkbox>
                <el-checkbox label="onSiteService">{{ $t('MemberRegistration.onSiteService') }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item :label="$t('MemberRegistration.note')" prop="note" label-width="auto">
              <el-input type="textarea" v-model="formData.note" :rows="4" :placeholder="$t('MemberRegistration.enterNote')" />
            </el-form-item>
          </div>

          <div class="form-actions">
            <el-button type="primary" class="submit-button" @click="submitForm" :disabled="isSubmitting">
              <span v-if="!isSubmitting">{{ $t('MemberRegistration.submit') }}</span>
              <span v-else>
                <i class="el-icon-loading"></i>
                {{ $t('MemberRegistration.submitting') }}
              </span>
            </el-button>
            <el-button class="reset-button" @click="resetForm">{{ $t('MemberRegistration.reset') }}</el-button>
          </div>
        </el-form>
      </div>
    </div>

    <el-dialog v-model="successDialogVisible" title="Success" align-center>
      <div class="success-content">
        <el-icon class="success-icon"><CircleCheck /></el-icon>
        <p>{{ $t('MemberRegistration.submissionSuccess') }}</p>
      </div>
      <template #footer>
        <el-button type="primary" @click="handleSuccessClose">{{ $t('MemberRegistration.ok') }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ArrowDown, Switch, Plus, CircleCheck } from '@element-plus/icons-vue';
import countryMixin from '@/mixins/countryMixin';
import { getUploadUrl, submitStoreApply, submitStoreUpgrade, sendPartnerVerifyCode, checkUserExist } from '@/api/api';

export default {
  name: 'MemberRegistration',
  mixins: [countryMixin],
  components: {
    ArrowDown,
    Switch,
    Plus,
    CircleCheck
  },
  props: {
    isFullscreen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        contactName: '',
        storeName: '',
        email: '',
        verifyCode: '',
        tel: '',
        country: '',
        postCode: '',
        location: '',
        taxNumber: '',
        website: '',
        workWithAnanda: '',
        howKnowAnanda: [],
        whyChooseAnanda: [],
        additionalInfo: '',
        subscribeNewsletter: false,
        officeArea: '',
        warehouse: '',
        staff: '',
        serviceCapabilities: [],
        note: '',
        businessLicense: []
      },
      fileList: [],
      uploadUrl: '#',
      isSubmitting: false,
      successDialogVisible: false,
      isSendingCode: false,
      codeCountdown: 0,
      supportedLanguages: {
        'English': 'en',
        '简体中文': 'zh',
        'Italiano': 'it',
        'Francais': 'fr',
        'Deutsch': 'de',
        'Dutch': 'nl',
        '日本語': 'ja',
        'Svenska': 'sv',
        'Magyar': 'hu',
        'Polski': 'pl',
        'Español': 'es',
        'Português': 'pt'
      },
      currentLanguage: 'English',
      postCodeValid: true,
      taxNumberValid: true,
      emailExists: false
    };
  },
  computed: {
    fullscreenBgStyle() {
      if (!this.isFullscreen) return {};
      return {};
    },
    formRules() {
      return {
        contactName: [
          { required: true, message: this.$t('MemberRegistration.requiredContactName'), trigger: 'blur' }
        ],
        storeName: [
          { required: true, message: this.$t('MemberRegistration.requiredStoreName'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('MemberRegistration.requiredEmail'), trigger: 'blur' },
          { type: 'email', message: this.$t('MemberRegistration.invalidEmail'), trigger: 'blur' }
        ],
        verifyCode: [
          { required: this.isFullscreen, message: this.$t('MemberRegistration.requiredVerifyCode'), trigger: 'blur' },
          { min: 4, max: 6, message: this.$t('MemberRegistration.invalidVerifyCode'), trigger: 'blur' }
        ],
        tel: [
          { required: true, message: this.$t('MemberRegistration.requiredTel'), trigger: 'blur' }
        ],
        country: [
          { required: true, message: this.$t('MemberRegistration.requiredCountry'), trigger: 'blur' }
        ],
        postCode: [
          { required: true, message: this.$t('MemberRegistration.requiredPostCode'), trigger: 'blur' },
          { validator: this.validatePostCodeRule, trigger: 'blur' }
        ],
        location: [
          { required: true, message: this.$t('MemberRegistration.requiredLocation'), trigger: 'blur' }
        ],
        taxNumber: [
          { required: true, message: this.$t('MemberRegistration.requiredTaxNumber'), trigger: 'blur' },
          { validator: this.validateTaxNumberRule, trigger: 'blur' }
        ],
        workWithAnanda: [
          { required: true, message: this.$t('MemberRegistration.requiredWorkWithAnanda'), trigger: 'change' }
        ],
        howKnowAnanda: [
          { required: this.formData.workWithAnanda === 'yes', message: this.$t('MemberRegistration.requiredHowKnowAnanda'), trigger: 'change' }
        ],
        whyChooseAnanda: [
          { required: this.formData.workWithAnanda === 'yes', message: this.$t('MemberRegistration.requiredWhyChooseAnanda'), trigger: 'change' }
        ],
        officeArea: [
          { required: true, message: this.$t('MemberRegistration.requiredOfficeArea'), trigger: 'change' }
        ],
        warehouse: [
          { required: true, message: this.$t('MemberRegistration.requiredWarehouse'), trigger: 'change' }
        ],
        staff: [
          { required: true, message: this.$t('MemberRegistration.requiredStaff'), trigger: 'change' }
        ],
        serviceCapabilities: [
          { required: true, message: this.$t('MemberRegistration.requiredServiceCapabilities'), trigger: 'change' }
        ]
      };
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get('lang');
    if (lang && this.supportedLanguages[lang]) {
      this.changeLanguage(lang);
    } else {
      const storedLang = localStorage.getItem('lang');
      if (storedLang && this.supportedLanguages[storedLang]) {
        this.changeLanguage(storedLang);
      }
    }
    this.fetchCountryOptions().then(() => {
      if (!this.isFullscreen) {
        this.loadUserDataFromStorage();
      }
    });

  },
  methods: {
    loadUserDataFromStorage() {
      const userEmail = localStorage.getItem('user_email');
      const userName = localStorage.getItem('userName');
      const userCountry = localStorage.getItem('userCountry');
      if (userEmail) {
        this.formData.email = userEmail;
      }
      if (userName) {
        this.formData.contactName = userName;
      }
      if (userCountry) {
        this.formData.country = userCountry;
      }
    },
    changeLanguage(lang) {
      this.currentLanguage = lang;
      const languageCode = this.supportedLanguages[lang];
      this.$store.dispatch('changeLanguage', { language: languageCode, friendlyName: lang });
      localStorage.setItem('lang', lang);
    },
    validatePostCode(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('MemberRegistration.requiredPostCode')));
      } else if (!/^[A-Za-z0-9\s-]+$/.test(value)) {
        callback(new Error(this.$t('MemberRegistration.invalidPostCode')));
      } else {
        callback();
      }
    },
    validatePostCodeRule(rule, value, callback) {
      if (value && !/^[A-Za-z0-9\s-]+$/.test(value)) {
        callback(new Error(this.$t('MemberRegistration.invalidPostCodeFormat')));
      } else {
        callback();
      }
    },
    validateTaxNumber(rule, value, callback) {
      if (!value) {
        callback(new Error(this.$t('MemberRegistration.requiredTaxNumber')));
      } else if (!/^[A-Za-z0-9-]+$/.test(value)) {
        callback(new Error(this.$t('MemberRegistration.invalidTaxNumber')));
      } else {
        callback();
      }
    },
    validateTaxNumberRule(rule, value, callback) {
      if (value && !/^[A-Za-z0-9-]+$/.test(value)) {
        callback(new Error(this.$t('MemberRegistration.invalidTaxNumberFormat')));
      } else {
        callback();
      }
    },
    async handleEmailBlur() {
      if (!this.isFullscreen || !this.formData.email) {
        this.emailExists = false;
        return;
      }
      try {
        const response = await checkUserExist(this.formData.email);
        if (response && response.code === 0 && response.message && response.message.toLowerCase().includes('already exist')) {
          this.emailExists = true;
          this.$alert(
            '<p>Account already exists.</p><p>Please reset your password using <strong>Forgot Password</strong>, or contact <strong><a href="mailto:service@ananda-drive.com" target="_blank">service@ananda-drive.com</a></strong> for assistance.</p>',
            'Error',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: 'OK',
              type: 'error',
              width: '500px'
            }
          );
        } else {
          this.emailExists = false;
        }
      } catch (error) {
        this.emailExists = false;
      }
    },
    async handleSendVerifyCode() {
      if (!this.formData.email) {
        this.$message.warning(this.$t('MemberRegistration.requiredEmail'));
        return;
      }
      this.isSendingCode = true;
      try {
        const response = await sendPartnerVerifyCode(this.formData.email);
        if (response && response.code === 0) {
          this.$message.success(this.$t('MemberRegistration.verifyCodeSent'));
          this.codeCountdown = 60;
          const timer = setInterval(() => {
            this.codeCountdown--;
            if (this.codeCountdown <= 0) {
              clearInterval(timer);
            }
          }, 1000);
        } else {
          this.$message.error(response?.message || this.$t('MemberRegistration.sendVerifyCodeFailed'));
        }
      } catch (error) {
        this.$message.error(this.$t('MemberRegistration.sendVerifyCodeFailed'));
      } finally {
        this.isSendingCode = false;
      }
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList;
      if (file.status === 'ready' && file.raw) {
        this.uploadFile(file.raw);
      }
    },
    handleUploadSuccess(response) {
      if (response && response.url) {
        if (!this.formData.businessLicense.includes(response.url)) {
          this.formData.businessLicense.push(response.url);
        }
      }
      this.$message.success(this.$t('MemberRegistration.uploadSuccess'));
    },
    handleUploadError() {
      this.$message.error(this.$t('MemberRegistration.uploadError'));
    },
    async handleCustomUpload(options) {
      const { file, onSuccess, onError } = options;
      try {
        const uploadResult = await getUploadUrl(file.name);
        if (uploadResult && uploadResult.code === 0 && uploadResult.putUrl) {
          await fetch(uploadResult.putUrl, {
            method: 'PUT',
            body: file,
            mode: 'cors',
            headers: {
              'Content-Type': file.type
            }
          });
          onSuccess({ url: uploadResult.key });
        } else {
          onError(new Error('Upload URL not received'));
        }
      } catch (error) {
        onError(error);
      }
    },
    async uploadFile(file) {
      try {
        const uploadResult = await getUploadUrl(file.name);
        if (uploadResult && uploadResult.code === 0 && uploadResult.putUrl) {
          await fetch(uploadResult.putUrl, {
            method: 'PUT',
            body: file,
            mode: 'cors',
            headers: {
              'Content-Type': file.type
            }
          });
          if (!this.formData.businessLicense.includes(uploadResult.key)) {
            this.formData.businessLicense.push(uploadResult.key);
          }
        } else {
          throw new Error('Upload URL not received');
        }
      } catch (error) {
        this.$message.error(this.$t('MemberRegistration.uploadError'));
        throw error;
      }
    },
    async submitForm() {
      try {
        await this.$refs.registrationForm.validate();
        
        if (this.emailExists) {
          this.$alert(
            '<p>Account already exists.</p><p>Please reset your password using <strong>Forgot Password</strong>, or contact <strong><a href="mailto:service@ananda-drive.com" target="_blank">service@ananda-drive.com</a></strong> for assistance.</p>',
            'Error',
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: 'OK',
              type: 'error',
              width: '500px'
            }
          );
          return;
        }
        
        this.isSubmitting = true;
        
        if (this.fileList.length > 0 && !this.formData.businessLicense) {
          const pendingFile = this.fileList.find(f => f.status !== 'success');
          if (pendingFile && pendingFile.raw) {
            await this.uploadFile(pendingFile.raw);
          }
        }
        
        const submitData = {
          contactName: this.formData.contactName,
          storeName: this.formData.storeName,
          email: this.formData.email,
          code: this.formData.verifyCode,
          tel: this.formData.tel,
          country: this.formData.country,
          postCode: this.formData.postCode,
          location: this.formData.location,
          taxNumber: this.formData.taxNumber,
          website: this.formData.website || '',
          businessLicense: Array.isArray(this.formData.businessLicense) ? this.formData.businessLicense.join(',') : (this.formData.businessLicense || ''),
          officeArea: this.formData.officeArea,
          warehouseArea: this.formData.warehouse,
          staffCount: this.formData.staff,
          serviceCapability: Array.isArray(this.formData.serviceCapabilities) ? this.formData.serviceCapabilities.join(',') : (this.formData.serviceCapabilities || ''),
          note: this.formData.note,
          isUseAnanda: this.formData.workWithAnanda === 'yes' ? 1 : 0,
          knowChannel: Array.isArray(this.formData.howKnowAnanda) ? this.formData.howKnowAnanda.join(',') : (this.formData.howKnowAnanda || ''),
          cooperateReason: Array.isArray(this.formData.whyChooseAnanda) ? this.formData.whyChooseAnanda.join(',') : (this.formData.whyChooseAnanda || ''),
          reasonExtra: this.formData.additionalInfo,
          isSubscribe: this.formData.subscribeNewsletter ? 1 : 0
        };
        
        const apiFn = this.isFullscreen ? submitStoreApply : submitStoreUpgrade;
        const response = await apiFn(submitData);
        
        if (response && response.code === 0) {
          this.successDialogVisible = true;
        } else {
          this.$message.error(response?.message || this.$t('MemberRegistration.submitFailed'));
        }
        this.isSubmitting = false;
      } catch (error) {
        this.$message.error(error?.response?.data?.message || this.$t('MemberRegistration.validationError'));
        this.isSubmitting = false;
      }
    },
    resetForm() {
      this.$refs.registrationForm.resetFields();
      this.fileList = [];
      this.codeCountdown = 0;
      this.formData = {
        contactName: '',
        storeName: '',
        email: '',
        verifyCode: '',
        tel: '',
        country: '',
        postCode: '',
        location: '',
        taxNumber: '',
        website: '',
        workWithAnanda: '',
        howKnowAnanda: [],
        whyChooseAnanda: [],
        additionalInfo: '',
        subscribeNewsletter: false,
        officeArea: '',
        warehouse: '',
        staff: '',
        serviceCapabilities: [],
        note: '',
        businessLicense: []
      };
    },
    handleSuccessClose() {
      this.successDialogVisible = false;
      this.resetForm();
      if (this.isFullscreen) {
        this.$router.push('/LoginPage');
      }
    }
  }
};
</script>

<style scoped>
.member-registration {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 20px;
}

.member-registration.fullscreen {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #0a2617 0%, #1a4d2e 50%, #0d3320 100%);
}

.member-registration.fullscreen::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 800px;
  height: 800px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 154, 68, 0.15) 0%, transparent 70%);
  animation: float 8s ease-in-out infinite;
  z-index: 0;
}

.member-registration.fullscreen::after {
  content: '';
  position: absolute;
  bottom: -30%;
  left: -10%;
  width: 600px;
  height: 600px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(46, 204, 113, 0.1) 0%, transparent 70%);
  animation: float 10s ease-in-out infinite reverse;
  z-index: 0;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) scale(1);
  }
  50% {
    transform: translateY(-30px) scale(1.05);
  }
}

.bike-decoration {
  position: absolute;
  z-index: 1;
  opacity: 0.08;
  pointer-events: none;
}

.bike-decoration.top-left {
  top: 10%;
  left: 5%;
  font-size: 200px;
  transform: rotate(-15deg);
}

.bike-decoration.bottom-right {
  bottom: 10%;
  right: 5%;
  font-size: 250px;
  transform: rotate(10deg);
}

.circuit-lines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  opacity: 0.3;
  background-image: 
    linear-gradient(rgba(0, 154, 68, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 154, 68, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  mask-image: radial-gradient(ellipse at center, black 30%, transparent 70%);
  -webkit-mask-image: radial-gradient(ellipse at center, black 30%, transparent 70%);
}

.fullscreen-header {
  position: absolute;
  top: 20px;
  left: 40px;
  right: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 10;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  height: 50px;
}

.language-switch {
  font-size: 14px;
}

.custom-dropdown .el-dropdown-link {
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.custom-dropdown-popper {
  min-width: 120px;
}

.member-registration.fullscreen .custom-dropdown .el-dropdown-link {
  color: white;
}

.member-registration.fullscreen .custom-dropdown .el-dropdown-link .el-icon {
  color: white;
}

.registration-wrapper {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  position: relative;
  z-index: 5;
}

.registration-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 40px;
  width: 100%;
  max-width: 900px;
}

.form-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.form-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin: 0 0 10px 0;
}

.form-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.form-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 2px solid rgb(0, 154, 68);
  display: inline-block;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-form-item__label {
  font-weight: 500;
  color: #333;
  padding-bottom: 8px;
  text-align: right;
}

.el-input__inner,
.el-select__wrapper,
.el-textarea__inner {
  border-radius: 6px;
  border-color: #e4e7ed;
  transition: all 0.3s ease;
}

.el-input__inner:focus,
.el-select__wrapper:focus-within,
.el-textarea__inner:focus {
  border-color: rgb(0, 154, 68) !important;
  box-shadow: 0 0 0 2px rgba(0, 154, 68, 0.1);
}

.upload-area {
  margin-top: 8px;
}

.upload-button {
  background-color: white !important;
  color: rgb(0, 154, 68) !important;
  border: 1px dashed rgb(0, 154, 68) !important;
  padding: 30px 60px;
}

.upload-button:hover {
  background-color: rgba(0, 154, 68, 0.05) !important;
}

.upload-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #999;
}

.conditional-section {
  background: #f9fafb;
  border-radius: 8px;
  padding: 20px;
}

.compact-section .el-form-item {
  margin-bottom: 16px;
}

.compact-section .el-form-item__label {
  white-space: normal;
  text-align: left;
  padding-bottom: 4px;
}

.form-row {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}

.form-row .el-form-item {
  flex: 1;
  min-width: 200px;
  margin-bottom: 0;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}

.form-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.submit-button {
  background-color: rgb(0, 154, 68) !important;
  border-color: rgb(0, 154, 68) !important;
  color: white !important;
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.submit-button:hover:not(:disabled) {
  background-color: rgb(0, 130, 57) !important;
  border-color: rgb(0, 130, 57) !important;
  box-shadow: 0 4px 12px rgba(0, 154, 68, 0.3);
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.verify-code-wrapper {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.verify-code-wrapper .el-input {
  flex: 1;
}

.verify-code-wrapper .el-input .el-input__wrapper {
  border-radius: 6px;
  height: 100%;
  padding: 0;
}

.verify-code-wrapper .el-input .el-input__inner {
  height: 100%;
  line-height: inherit;
  padding: 0 15px;
}

.send-code-btn {
  padding: 0 16px;
  white-space: nowrap;
  border-radius: 6px;
  height: 40px;
  line-height: 40px;
  min-width: 120px;
}

.reset-button {
  padding: 12px 40px;
  font-size: 16px;
  border-radius: 6px;
}

.email-exists-warning {
  color: #e74c3c;
  font-size: 13px;
  margin-top: 8px;
  line-height: 1.6;
}

.email-exists-warning p {
  margin: 4px 0;
}

.email-exists-warning a {
  color: #e74c3c;
  text-decoration: underline;
}

.success-content {
  text-align: center;
  padding: 20px;
}

.success-icon {
  font-size: 60px;
  color: rgb(0, 154, 68);
  margin-bottom: 20px;
}

.success-content p {
  font-size: 16px;
  color: #333;
  margin: 0;
}

.el-radio-group {
  display: flex;
  gap: 30px;
}

.el-radio__inner {
  width: 18px;
  height: 18px;
}

.el-radio__inner.is-checked {
  background-color: rgb(0, 154, 68);
  border-color: rgb(0, 154, 68);
}

.el-checkbox__inner.is-checked {
  background-color: rgb(0, 154, 68);
  border-color: rgb(0, 154, 68);
}

.el-select .el-input__inner {
  height: 40px;
  line-height: 40px;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }
  
  .checkbox-grid {
    grid-template-columns: 1fr;
  }
  
  .registration-container {
    padding: 20px;
  }
  
  .fullscreen-header {
    left: 20px;
    right: 20px;
    top: 15px;
  }
  
  .member-registration.fullscreen {
    padding: 20px;
  }
}
</style>